import { render, staticRenderFns } from "./ClassNoteLessonSetup.vue?vue&type=template&id=8a6793f6"
import script from "./ClassNoteLessonSetup.vue?vue&type=script&lang=js"
export * from "./ClassNoteLessonSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports